import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import css from './Menu.module.scss';

type Props = {
  name: string;
  jsonVideo: {};
};
export default function MenuItem(props: Props) {
  const { name, jsonVideo } = props;
  const [isHover, setIsHover] = useState(false);
  const itemRef = useRef(null);
  const [anim, setAnim] = useState(null);
  useEffect(() => {
    if (jsonVideo) {
      // @ts-ignore
      if (window && window?.lottie !== undefined) {
        setAnim(
          // @ts-ignore
          window.lottie.loadAnimation({
            container: itemRef.current, // the dom element that will contain the animation
            loop: true,
            renderer: 'canvas', // "svg", "html"
            autoplay: false,
            animationData: jsonVideo, // the path to the animation json
          }),
        );
      }
    }
    // @ts-ignore
  }, [jsonVideo]);

  useEffect(() => {
    if (isHover) {
      // @ts-ignore
      anim.play();
    } else if (!isHover && anim !== null) {
      // @ts-ignore
      anim.stop();
    }
  }, [anim, isHover]);

  return (
    <div
      className={cn(css.menuItem, isHover && css.hover)}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {/* <Lottie loop animationData={jsonVideo} play={isHover} goTo={isHover ? 0 : 0} className={css.animation} /> */}
      <div ref={itemRef} />
      <p>{name}</p>
    </div>
  );
}
